module.exports = __webpack_public_path__ + "static/media/appStore.95fb742c.png";